import { useBounceGlobalValues, useTranslation } from "@bounce/i18n"

export const useSEO = () => {
  const [t] = useTranslation("marketing-ls-app")
  const bounceGlobals = useBounceGlobalValues()

  const metaTitle = t("page.appDownloadScreen.metaTitle", "Download The Bounce Luggage Storage App")

  const metaDescription = t(
    "page.appDownloadScreen.metaDescription",
    "Be free to explore wherever you go with the Bounce luggage storage app. Find affordable and convenient locations via the app in over {{numCities}} cities worldwide.",
    { numCities: bounceGlobals.numCities },
  )
  return {
    metaTitle,
    metaDescription,
  }
}
